import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { unescapeHTML } from 'underscore.string';

import SearchBox from 'components/site/SearchBox';
import DropdownItem from 'components/v2/dropdowns/DropdownItem';
import Badge from 'components/v2/Badge';

const renderItem = (item, isHighlighted, searchKey, badgeLabel) => {
  const value = unescapeHTML(item[searchKey]);

  return (
    <DropdownItem
      isHiglighted={isHighlighted}
      key={item[searchKey]}
      className="list-group-item"
    >
      <div className="flex -mx-4">
        {badgeLabel && (
          <div className="my-auto px-4 w-36">
            <Badge rounded color="brand" className="label">
              {badgeLabel}
            </Badge>
          </div>
        )}
        <div className="w-2/5 px-4">
          <span className="font-bold capitalize">{value.toLowerCase()}</span>
        </div>
      </div>
    </DropdownItem>
  );
};

const AutocompleteSearch = (props) => {
  const {
    items,
    autocompleteOptions,
    searchKey,
    badgeLabel,
    placeholder,
    defaultValue,
    onChange,
    onSelect,
    renderItem,
    inputStyle,
    nGramLength,
  } = props;

  const [searchResults, setSearchResults] = useState(items);
  const [searchText, setSearchText] = useState('');

  const clear = () => {
    setSearchResults([]);
  };

  const onResultSelect = (_value, item) => {
    clear();
    onSelect(item);
  };

  const getSearchResults = (query) => {
    const searchData =
      autocompleteOptions && autocompleteOptions.length
        ? autocompleteOptions
        : items;
    const results = searchData.reduce((data, item) => {
      const searchValue = item[searchKey];
      if (
        searchValue &&
        searchValue.toLowerCase().includes(query.toLowerCase())
      ) {
        data[searchValue] = item;
      }
      return data;
    }, {});
    setSearchResults(Object.keys(results).map((key) => results[key]));
  };

  const handleChange = (searchText) => {
    setSearchText(searchText);
    if (onChange) {
      onChange(searchText);
    }
  };

  return (
    <SearchBox
      items={searchResults}
      clear={clear}
      search={getSearchResults}
      placeholder={placeholder}
      defaultValue={defaultValue}
      value={searchText}
      onChange={handleChange}
      nGramLength={nGramLength}
      onSelect={onResultSelect}
      getItemValue={(item) => item[searchKey]}
      renderItem={(item, isHighlighted) =>
        renderItem(item, isHighlighted, searchKey, badgeLabel)
      }
      inputStyle={inputStyle}
    />
  );
};

AutocompleteSearch.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  renderItem: PropTypes.func,
  inputStyle: PropTypes.object,
};

AutocompleteSearch.defaultProps = {
  renderItem,
};

export default AutocompleteSearch;
